import React, { useCallback } from 'react';
import { ToastContainer } from "react-toastify";
import { Link } from 'react-router-dom';
import { BsPencil } from "react-icons/bs";
import {DateFormat} from '../../utils/DateFormat';

const ListSupportTicket = ({ handleColumnChange, handleAssign, rows = [], statusClasses = {}, priorityClasses = {}, selectedTickets,onSelectTicket,onSelectAll,offset }) => {

    const handleSupportColumnChange = useCallback((row, type) => {
        handleColumnChange(row.id, type, 'support');
    }, [handleColumnChange]);

    const handleSupportAssign = useCallback((id) => {
        if (!id) return;
        handleAssign(id, 'support');
    }, [handleAssign]);

    const allSelected = rows.length > 0 && rows.every(row => selectedTickets.includes(row.id));

    return (
        <>
            <table className="table table-sm table-nowrap">
                <thead>
                    <tr>
                        <th style={{ width: '1%' }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={allSelected}
                            onChange={e => onSelectAll(e.target.checked)}
                            aria-label="Select all"
                            disabled={rows.length === 0}
                        />
                        </th>
                        <th scope="col">#</th>
                        <th scope="col">Ticket No</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Customer Name</th>
                        <th scope="col">Title</th>
                        <th scope="col">Assign To</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Closed On</th>
                        <th scope="col">Status</th>
                        <th scope="col">Priority</th>
                        <th scope="col">Assign</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.length > 0 ? (
                        rows.map((row, index) => (
                            <tr key={row.id}>
                                <td>
                                    <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={selectedTickets.includes(row.id)}
                                    onChange={e => onSelectTicket(row.id, e.target.checked)}
                                    aria-label={`Select ticket ${row.ticket_no}`}
                                    disabled={rows.length === 0}
                                    />
                                </td>
                                <th scope="row">{offset + index + 1}</th>
                                <td><Link to={`/tickets/${row.id}/basic`}>{row.ticket_no || 'N/A'}</Link></td>
                                <td> {row?.customerProduct?.product?.name || 'N/A'} </td>
                                <td>{row.customerProduct?.quantity || 'N/A'}</td>
                                <td>{row.customer?.company || 'N/A'}</td>
                                <td>{row.title || 'No Title'}</td>
                                <td>{row.assignedTo?.name || 'Unassigned'}</td>
                                <td>{DateFormat(row.createdAt || '')}</td>
                                <td className='text-center'>{row.status === 'closed' ? DateFormat(row.updatedAt || '') : '--'}</td>
                                <td>
                                    <span
                                        className={`editable-field badge ${statusClasses[row.status] || ''}`}
                                        onClick={() => handleSupportColumnChange(row, 'status')}
                                    >
                                        {row.status?.charAt(0).toUpperCase() + row.status.slice(1) || 'N/A'}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        className={`editable-field badge ${priorityClasses[row.priority] || ''}`}
                                        onClick={() => handleSupportColumnChange(row, 'priority')}
                                    >
                                        {row.priority?.charAt(0).toUpperCase() + row.priority.slice(1) || 'N/A'}
                                    </span>
                                </td>
                                <td>
                                    <Link to="#" onClick={() => handleSupportAssign(row.id)}>
                                        <BsPencil title="Assign" />
                                    </Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" className="text-center">No data found</td>
                        </tr>
                    )
                    }
                </tbody>
            </table>
            <ToastContainer />
        </>
    );
};

export default ListSupportTicket;
